module.exports = __webpack_public_path__ + "static/media/banner_1920x350-3.8e8ebce9.jpg";